import greenBg from './green-bg.jpg';
import guaranteesBg from './guarantees-bg.png';
import notesList from './notes-list.svg';
import preview from './preview.jpg';
import subscribeBg from './subscribe-bg.png';

export * from './icons';
export { greenBg, guaranteesBg, notesList, preview, subscribeBg };
